export default "/images/co-img-1.png?a4c4222f6ad16848cab67a0d13fe2203";